import Vue from 'vue'
import Main from './main.vue'
let ConfirmBoxConstructor = Vue.extend(Main)

let instance
let instances = []
let seed = 1

const ConfirmBox = function (options) {
  options = options || {}
  // let userOnClose = options.onClose
  let id = 'message_' + seed++

  // options.onClose = function () {
  //   ConfirmBox.close(id, userOnClose)
  // }
  instance = new ConfirmBoxConstructor({
    data: options
  })
  if (instances.length > 0) {
    instances[0].close()
    instances.splice(0, 1)
  }
  instance.id = id
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  // instance.dom.style.zIndex = PopupManager.nextZIndex()
  instance.dom.style.zIndex = 100
  instances.push(instance)
  return instance.vm
}

// ConfirmBox.close = function (id, userOnClose) {
//   for (let i = 0, len = instances.length; i < len; i++) {
//     if (id === instances[i].id) {
//       if (typeof userOnClose === 'function') {
//         userOnClose(instances[i])
//       }
//       instances.splice(i, 1)
//       break
//     }
//   }
// }

export default ConfirmBox
